import React from 'react';
import './NetworkSection.scss';

const NetworkSection = () => {
  return (
    <div className="unfm-network">
      <section className="network">
        <div className="network__container">
          <h2 className="network__title">
            Un réseau national d&apos;associations mobilisées
          </h2>

          <p className="network__subtitle">
            UNFM 2.0 s&apos;appuie sur un réseau d&apos;associations
            partenaires réparties dans toutes les régions du Maroc, qui
            sélectionnent les candidates, affectent les formateurs et
            assurent le suivi des parcours de formation.
          </p>

          {/* Map / illustration goes here (e.g. Morocco map with association markers) */}
          <div className="network__map-card" />

          <a href="/contact" className="network__cta">
            Votre association souhaite rejoindre le réseau UNFM&nbsp;?
            Contactez-nous
          </a>
        </div>
      </section>
    </div>
  );
};

export default NetworkSection;